import { useMutation } from "react-query";

import { deleteEpd } from "~/components/Forms/DealerPassportForm2/requests/deleteEpd";

export default function useDeleteEpd() {
  return useMutation({
    mutationFn: ({ dealerId, epdId }: { dealerId: string; epdId: number }) =>
      deleteEpd(dealerId, epdId),
  });
}
